<template>
  <layout :show-profile="true">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 pt-12">
      <div class="flex flex-col">
        <div
          class="-my-2 py-2 sm:overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
        >
          <!-- Page Header: start -->
          <div class="md:flex md:items-center md:justify-between">
            <div class="flex-1 min-w-0">
              <h2
                class="text-2xl font-light leading-7 text-gray-900 sm:text-2xl sm:leading-9 sm:truncate"
              >
                Meine Vorlagen
              </h2>
            </div>
            <div class="mt-4 flex md:mt-0 md:ml-4"></div>
          </div>
          <!-- Page Header: end -->

          <!-- Tabs: start -->
          <div class="mt-4 mb-8">
            <div class="border-b border-gray-200">
              <nav class="-mb-px flex space-x-8">
                <Link
                  :href="route('profile.index')"
                  class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm"
                >
                  Profil
                </Link>
                <Link
                  :href="route('profile.templates.index')"
                  class="border-markencode-red text-markencode-red whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm"
                >
                  Vorlagen
                </Link>
              </nav>
            </div>
          </div>
          <!-- Tabs: end -->

          <div>
            <!-- Filter: start -->
            <div class="flex mb-4">
              <div class="w-11/12 mr-2">
                <div class="mt-1 relative rounded-md shadow-sm">
                  <div
                    class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                  >
                    <svg
                      class="h-5 w-5 text-gray-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <input
                    type="search"
                    class="mt-1 pl-10 focus:ring-gray-400 focus:border-gray-400 block w-full sm:text-sm border-gray-300 rounded-md"
                    placeholder="Suchen nach..."
                    v-model="form.search"
                  />
                </div>
              </div>

              <div class="w-1/12 text-center mt-3">
                <button v-if="isFiltered" v-tooltip.left="'Filter zurücksetzen'" @click="reset">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-5 h-5 text-gray-500 hover:text-markencode-blue">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                </button>

                <div v-if="!isFiltered">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-5 h-5 text-gray-300">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                </div>
              </div>
            </div>
            <!-- Filter: end -->

            <!-- List: start -->

            <div class="mt-8 flow-root">
              <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div
                  class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
                >
                  <div
                    class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
                  >
                    <table class="min-w-full divide-y divide-gray-300">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            scope="col"
                            class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                          >
                            Name
                          </th>
                          <th
                            scope="col"
                            class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Erstellt
                          </th>
                          <th
                            scope="col"
                            class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Phasen
                          </th>

                          <th
                            scope="col"
                            class="relative py-3.5 pl-3 pr-4 sm:pr-6"
                          ></th>
                        </tr>
                      </thead>
                      <tbody class="divide-y divide-gray-200 bg-white">
                        <tr
                          v-for="(template, idx) in templates"
                          :key="template.id"
                        >
                          <td
                            class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                          >
                            {{ template.name }}
                          </td>
                          <td
                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                          >
                            {{ template.created_at | formatDateTime }}
                          </td>
                          <td
                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                          >
                            <ul>
                              <li v-for="(phase, idx) in getPhases(template)" :key="idx" class="text-xs">
                                {{ phase }}
                              </li>
                            </ul>
                          </td>

                          <td
                            class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                          >
                            <a
                              href="#"
                              @click.stop.prevent="deleteTemplate(template)"
                              class="text-markencode-red hover:text-markencode-red"
                              >Löschen</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- List: end -->
          </div>
        </div>
      </div>
    </div>

    <confirm-modal
      v-if="confirmModal.visible"
      :headline="confirmModal.headline"
      :text="confirmModal.text"
      @close="confirmModal.visible = false"
      @confirm="deleteTemplateConfirmed"
    ></confirm-modal>
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import ConfirmModal from '@/Shared/ConfirmModal.vue';

import { pickBy, debounce, mapValues, some, isNotEmpty } from 'lodash';

export default {
  metaInfo: { title: 'Meine Vorlagen' },

  components: {
    Layout,
    ConfirmModal,
  },

  props: {
    user: Object,
    templates: Array,
    filters: Object,
  },

  data() {
    return {
      confirmModal: {
        visible: false,
        itemId: null,
        headline: 'Vorlage löschen',
        text: '',
      },
      form: {
        search: this.filters.search,
      },
    };
  },

  computed: {
    isFiltered() {
      return some(this.form, isNotEmpty);
    },
  },

  watch: {
    form: {
      handler: debounce(function () {
        let query = pickBy(this.form);
        
        // console.log(query);
        this.$inertia.replace(
          this.route(
            'profile.templates.index',
            Object.keys(query).length ? query : { remember: 'forget' }
          )
        );
      }, 120),
      deep: true,
    },
  },

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null);
    },

    deleteTemplate(template) {
      this.confirmModal.itemId = template.id;
      this.confirmModal.text = `Soll die Vorlage ${template.name} wirklich gelöscht werden?`;
      this.confirmModal.visible = true;
    },

    deleteTemplateConfirmed() {
      
      if (!this.confirmModal.itemId) return;

      this.sending = true;

      this.$inertia.delete(
        this.route('profile.templates.delete', {
          id: this.confirmModal.itemId,
        }),
        {
          preserveScroll: true,
          onSuccess: (page) => {
            this.sending = false;
            this.confirmModal.visible = false;
          },
        }
      );

    },

    getPhases(template) {
      let phases = [];

      let phasesJson = JSON.parse(template.phases);
      // console.log(phasesJson);

      phasesJson.forEach((phase, index, array) => {
        phases.push(phase.name);
      });


      // return phases.join("\n");
      return phases;
    },
  },

  // computed: {
    // allPhases() {
    //   // let phases = this.templates.map((template) => {
        
    //   //   console.log(JSON.parse(template.phases));
    //   //   // return phase;
    //   // });

      

    //   let phases = [];
    //   this.templates.forEach((template, index, array) => {
    //     phases.push(template.name);
    //   });

    //   return phases;

    //   // let phases = this.templates.
    //   // console.log(JSON.parse(this.phases));
    // },
  // },
};
</script>
